(function ($) {
  DJ.addBehavior('durationInit', '.js-form-item-duration', {
    attach: function () {
      const durationContainer = this;
      const durationInput = durationContainer.querySelector('.form-item-duration');
      const durationBlock = document.createElement('div');
      const durationMin = parseInt(durationInput.getAttribute('data-duration-min'), 10) || 6;
      const durationMax = parseInt(durationInput.getAttribute('data-duration-max'), 10) || 12;
      const pipsActiveClass = 'noUi-value-horizontal--active';

      /**
       * Return false if no duration input.
       */
      if (!durationInput) {
        return false;
      }

      /**
       * noUiSlider init.
       */
      durationBlock.classList.add('duration-block');
      durationContainer.appendChild(durationBlock);

      noUiSlider.create(durationBlock, {
        start: [durationInput.value || durationMin],
        range: {
          min: [durationMin],
          max: [durationMax]
        },
        step: 1,
        pips: {
          mode: 'steps',
          stepped: true,
          density: 4,
          format: wNumb({
            decimals: 0,
            suffix: ' mois'
          })
        }
      });

      // When the slider value changes, update the input
      const pips = durationBlock.querySelectorAll('.noUi-value');
      const pipsArr = Array.prototype.slice.call(pips);

      durationBlock.noUiSlider.on('update', function (values, handle) {
        const durationValue = Math.round(values);
        durationInput.value = durationValue;

        pipsArr.forEach((item) => {
          item.classList.remove('noUi-value-horizontal--active');
        });

        pipsArr[durationValue - durationMin].classList.add('noUi-value-horizontal--active');
      });

      // Update slider on pip click.
      function clickOnPip() {
        const pipsItem = this;
        const value = Number(pipsItem.getAttribute('data-value'));

        pipsArr.forEach((item) => {
          item.classList.remove(pipsActiveClass);
        });

        pipsItem.classList.add(pipsActiveClass);
        durationBlock.noUiSlider.set(value);
      }

      pipsArr.forEach((item) => {
        item.addEventListener('click', clickOnPip);
        item.setAttribute('data-text', item.innerHTML);
      });

      return true;
    }
  });
})(jQuery);
